export const LOCAL_TIME_PREFIX = 'local!';

const TimeFormats = {
  DATABASE_DATE: '%Y-%m-%d',
  DATABASE_DATETIME: '%Y-%m-%d %H:%M:%S',
  DATABASE_DATETIME_REVERSE: '%d-%m-%Y %H:%M:%S',
  INTERNATIONAL_DATE: '%d/%m/%Y',
  TIME: '%H:%M:%S',
  US_DATE: '%m/%d/%Y',
};

export default TimeFormats;
